import { defineComponent, h } from 'vue';
import { useInspectionReport } from '@/ui/components/inspectionReport/useInspectioReport';

export const ConductedBy = defineComponent({
  name: 'ConductedBy',
  setup() {
    const { resource } = useInspectionReport();

    return function render() {
      return h('div', [resource.value?.conducted_by]);
    };
  },
});
